import { render, staticRenderFns } from "./AppLayoutDefault.vue?vue&type=template&id=be8c46e2&scoped=true&"
import script from "./AppLayoutDefault.vue?vue&type=script&lang=js&"
export * from "./AppLayoutDefault.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutDefault.vue?vue&type=style&index=0&id=be8c46e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8c46e2",
  null
  
)

export default component.exports